import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import DocumentsTabListItemUploading from "./DocumentsTabListItemUploading"
import DocumentsTabListItem from "./DocumentsTabListItem"
import DropFilesHiddenProco from "./DropFilesHiddenProco"
import { activeProcoDocuments, deletedProcoDocuments } from "../../../../../lib/docs"
import classes from './DocumentsTabListItem.module.css'

export default function DocumentsPannel({uploadedFile, uploadPermission, updatePermission, deletePermission, restorePermission, hardDeletePermission, caseAttorneyId}) {
    const [uploaded, setUploaded] = useState(null)
    const [activeData, setActiveData] = useState(null)
    const [deletedData, setDeletedData] = useState(null)
    const [deleteUploadedDocumentFlag, setDeleteUploadedDocumentFlag] = useState(0)

    const searchedDocumentsResult = useSelector(state => state.procofiles.filterResult)
    const activeCase = useSelector(state => state.case.activeCase) 


    const removeFileWithId = (id) => {
        setUploaded(prevState => {
            const index = prevState.findIndex(object => {
                return object.id == id
            })
            if (index !== -1) {
                prevState.splice(index, 1)
            }
            if (prevState.length == 0) {
                return null
            }
            
            return prevState
        })
         setDeleteUploadedDocumentFlag(prev => prev+1)
    }

    useEffect(() => {
        if (activeCase) {
            const sortByDate = (a, b) => new Date(b.created_at) - new Date(a.created_at)
            const forAttorney = (items) => items.filter(item => item.case_attorney_id == caseAttorneyId)

            setActiveData(forAttorney(activeProcoDocuments(activeCase.procodocs_documents).sort(sortByDate)))
            setDeletedData(forAttorney(deletedProcoDocuments(activeCase.procodocs_documents).sort(sortByDate)))
        }

        setUploaded(uploadedFile)

    }, [activeCase, uploadedFile, caseAttorneyId])

    return <>
        <DropFilesHiddenProco uploadfile={(val) => {setUploaded(val)}} uploadPermission={uploadPermission}>
            <table className="table-border-radius-8">
                <thead>
                    <tr>
                        <th>Document Name</th>
                        <th>Date Uploaded</th>
                        <th>Uploaded By</th>
                        <th>Source</th>
                        <th>Document Type</th>
                        <th>Practice</th>
                        {/* <th>Verified</th> */}
                        <th>Viewed</th>
                        <th>Verified</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                        {(uploaded && uploaded.length > 0) && uploaded.map(item => (
                            <DocumentsTabListItemUploading key={item.id} data={item} file={item} removeFile={removeFileWithId}/>
                        ))} 

                        {!searchedDocumentsResult && activeData && activeData.map(item => (
                            <DocumentsTabListItem key={item.id} data={item} updatePermission={updatePermission} deletePermission={deletePermission} hardDeletePermission={hardDeletePermission}/>
                        ))}
                        {searchedDocumentsResult && searchedDocumentsResult.length > 0 && searchedDocumentsResult.map(item => (
                            <DocumentsTabListItem key={item.id} data={item} updatePermission={updatePermission} deletePermission={deletePermission} hardDeletePermission={hardDeletePermission}/>
                        ))}
                        {searchedDocumentsResult && searchedDocumentsResult.length == 0 && <tr>
                            <td colSpan="8">No results found!</td>
                        </tr>}

                        {!searchedDocumentsResult && deletedData && deletedData.length > 0 && (
                            <>
                                <tr className={classes.deleted_section_header}>
                                    <td colSpan="9">Deleted documents</td>
                                </tr>
                                {deletedData.map(item => (
                                    <DocumentsTabListItem key={`deleted-${item.id}`} data={item} isDeleted={true} restorePermission={restorePermission} hardDeletePermission={hardDeletePermission}/>
                                ))}
                            </>
                        )}
                    </tbody>
            </table>
        </DropFilesHiddenProco>        
    </>
}